import React, { Component } from "react";
import { logout } from "../core/auth";
import Logo from "./logo";
import trocaSenhaImg from "../img/troca-senha.png";
import { isUndefined } from "util";

class Sucesso extends Component {

  constructor(props){
    super(props);
    //console.log(this.props.location.state);
    // debugger;
    if(isUndefined(this.props.location.state)) {
      this.state = {message:{msg:"Atenção! Não se esqueça de trocar a senha nos dispositivos móveis (celular, notebook, etc) em que você usou a nossa rede WI-FI para que não ocorra o bloqueio da sua conta de acesso."}};
    } else {
      this.state = {message:this.props.location.state.split("\\n")};
    }
  }

  // componentDidMount(){
  //   const { msg } = this.props.match.params;
  //   this.setState({message:msg});
  //   console.log(msg );
  // }

  render() {
    logout();
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <h5 className="card-title text-center margin-top">
              <img src={trocaSenhaImg} className="img-responsive troca-senha" alt="Confirmação de Dados" />
            </h5>
            <p>Senha alterada com sucesso! </p>
            {this.state.message && 
                this.state.message.map((v, i) =>
                <h1>
                  {v}
                </h1>)}
            <Logo />
          </div>
        </div>
      </div>
    );
  }
}

export default Sucesso;